import {onBeforeUnmount, onMounted, readonly, ref} from 'vue';
import {storeToRefs} from 'pinia';
import {useAuth, useLogger, useNuxtApp} from '#imports';
import {useLazyFeatureFlag} from '@malt/feature-flags';

export function useProfileViewBlocker() {
    const nuxtApp = useNuxtApp();
    const logger = useLogger();
    const {loggedIn} = storeToRefs(useAuth());
    const showProfileViewBlocker = ref(false);

    async function isProfileViewBlockerRemoved() {
        try {
            return await nuxtApp.runWithContext(() => useLazyFeatureFlag('remove-profile-view-blocker'));
        } catch (error) {
            logger.error('Failed to fetch remove-profile-view-blocker feature flag', error);
            return false;
        }
    }

    async function handleScroll() {
        if (window.scrollY <= window.innerHeight / 2) {
            return;
        }

        window.removeEventListener('scroll', handleScroll);
        showProfileViewBlocker.value = !(await isProfileViewBlockerRemoved());
    }

    onMounted(() => {
        if (!loggedIn.value) {
            window.addEventListener('scroll', handleScroll);
        }
    });

    onBeforeUnmount(() => {
        window.removeEventListener('scroll', handleScroll);
    });

    return {showProfileViewBlocker: readonly(showProfileViewBlocker)};
}
